export default "__VITE_ASSET__BKUBONi6__"